(function () {
  function initCakeTestimonials(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-cake-slider]').forEach(function (slider) {
      if (slider.dataset.cakeInit === 'true') return;
      slider.dataset.cakeInit = 'true';

      var track = slider.querySelector('[data-cake-track]');
      if (!track) return;

      var allCards = track.querySelectorAll('.cake-home__testimonial');
      var dots = slider.querySelectorAll('[data-cake-dot]');
      var autoplay = track.dataset.autoplay === 'true';
      var delay = parseInt(track.dataset.delay || '3000', 10);
      var timer = null;

      if (!allCards.length) return;

      function getCardsPerView() {
        if (window.innerWidth <= 749) return 1;
        if (window.innerWidth <= 989) return 2;
        return 3;
      }

      function getGap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || 20);
      }

      function getCardWidth() {
        var firstCard = track.querySelector('.cake-home__testimonial');
        return firstCard ? firstCard.offsetWidth : 0;
      }

      function getStepSize() {
        return getCardWidth() + getGap();
      }

      function getTotalPages() {
        return Math.max(1, Math.ceil(allCards.length / getCardsPerView()));
      }

      function getCurrentPage() {
        var step = getStepSize();
        var perView = getCardsPerView();
        if (!step) return 0;

        var rawIndex = Math.round(track.scrollLeft / step);
        var page = Math.round(rawIndex / perView);

        return Math.max(0, Math.min(page, getTotalPages() - 1));
      }

      function updateDots() {
        var currentPage = getCurrentPage();

        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === currentPage);
        });
      }

      function goToPage(pageIndex) {
        var perView = getCardsPerView();
        var step = getStepSize();
        var maxPage = getTotalPages() - 1;
        var safePage = Math.max(0, Math.min(pageIndex, maxPage));
        var target = safePage * perView * step;

        track.scrollTo({
          left: target,
          behavior: 'smooth'
        });

        window.setTimeout(updateDots, 300);
      }

      function nextPage() {
        var current = getCurrentPage();
        var total = getTotalPages();
        var next = current + 1;

        if (next >= total) next = 0;
        goToPage(next);
      }

      function startAutoplay() {
        if (!autoplay || getTotalPages() <= 1) return;
        stopAutoplay();
        timer = window.setInterval(nextPage, delay);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index') || '0', 10);
          goToPage(index);
          startAutoplay();
        });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateDots);
      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('touchstart', stopAutoplay, { passive: true });
      slider.addEventListener('touchend', startAutoplay, { passive: true });

      window.addEventListener('resize', updateDots);

      updateDots();
      startAutoplay();
    });
  }

  function initCakeProductFilters(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-cake-filters]').forEach(function (filterWrap) {
      if (filterWrap.dataset.cakeFilterInit === 'true') return;
      filterWrap.dataset.cakeFilterInit = 'true';

      var section = filterWrap.closest('.cake-home');
      if (!section) return;

      var grid = section.querySelector('[data-cake-product-grid]');
      if (!grid) return;

      var chips = filterWrap.querySelectorAll('[data-filter-chip]');
      var cards = grid.querySelectorAll('[data-product-item]');

      if (!chips.length || !cards.length) return;

      function applyFilter(value) {
        cards.forEach(function (card) {
          var category = card.getAttribute('data-category') || '';

          if (value === 'all' || category === value) {
            card.classList.remove('is-hidden');
          } else {
            card.classList.add('is-hidden');
          }
        });

        chips.forEach(function (chip) {
          var active = chip.getAttribute('data-filter-value') === value;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var value = chip.getAttribute('data-filter-value') || 'all';
          applyFilter(value);
        });
      });

      var activeChip = filterWrap.querySelector('.cake-home__chip.is-active');
      var defaultValue = activeChip
        ? activeChip.getAttribute('data-filter-value') || 'all'
        : 'all';

      applyFilter(defaultValue);
    });
  }

  function initCakeHome(scope) {
    initCakeTestimonials(scope);
    initCakeProductFilters(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCakeHome(document);
    });
  } else {
    initCakeHome(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCakeHome(event.target);
  });
})();